import React from 'react';
import question from 'assets/question-bubble.png';

import { useStateBus } from '~/state/bridge';
import {
  getTargetingReady,
  retrieveFBTargetingSpec,
} from '~/state/Targeting/selectors';

import Reach from './Reach';
import Helpbox from './Helpbox';
import usePotentialReach from '../hooks/usePotentialReach';
import { useAuthSelector } from '~/theseus/containers/Auth';
import { useAccountQuery } from '~/theseus/hooks/queries';

const monthlyHelpbox = 'Number of people active on your specified platforms over the past month who match your given targeting specifications';

const potentialReachHelpbox = 'Potential Reach estimates how many people your ad could be shown to depending on the targeting and ad placement options you select while creating an ad. The number of people your campaign actually ends up reaching depends on your budget and number of days that you run your ad.';

export const PotentialReach = () => {
  const accessToken = useAuthSelector(state => state.context.authToken);
  const [accountId] = useAccountQuery();
  const targeting = useStateBus(retrieveFBTargetingSpec);
  const targetingReady = useStateBus(getTargetingReady);

  const { monthly } = usePotentialReach(accountId, accessToken, targeting, targetingReady);

  return (
    <div className="collage collage--enabled">
      <div className="collage__header">
        <div className="row centered">
          <h2>Potential Reach</h2>
          <Helpbox icon={question} boxStyles={{ width: '300px' }}>
            { potentialReachHelpbox }
          </Helpbox>
        </div>
      </div>
      <div>
        <Reach
          title="Monthly Reach"
          helpboxText={monthlyHelpbox}
          numberPeople={monthly}
        />
      </div>
    </div>
  );
};
